const MasterDataMutationTypes = {
  UPDATE_LOADING_STATE: 'UPDATE_LOADING_STATE',
  UPDATE_MASTER_DATA: 'UPDATE_MASTER_DATA',
  UPDATE_FILES: 'UPDATE_FILES',
};

export default MasterDataMutationTypes;
